import { Form, Input, InputNumber, Button, message} from "antd"
import axios from "axios"
import { useContext,  useEffect,  useState  } from "react"
import { useHistory, useParams} from "react-router-dom"
import { UserContext } from "../Context/UserContext"
const GamesForm = () => {
    const [gameEdit, setGameEdit] = useState({
        name: "",
        genre: "",
        platform: "",
        release: "",
        singlePlayer: "",
        multiplayer: "",
        image_url: ""
    })
    const [ready, setReady] = useState(false)
    const [user] = useContext(UserContext)
    let history = useHistory()
    let {id} = useParams()
    console.log(id)
   
    useEffect(() => {
        if (!id){
            setReady(true)
        } else {
            const userEdit = async () => {
                await axios.get(`https://super-bootcamp-backend.sanbersy.com/api/games/${id}`, {headers: {"Authorization" : "Bearer "+ user.token}})
                    .then((res) => {
                        setGameEdit (res.data)
                        setReady(true)
                    }).catch((err) => {
                        console.log(err)
                    })
            } 
            userEdit()
        }  
    },[id, user.token])

   
   
    const onFinish = (values) => {
        if(!id) {
            values.release = String(values.release)
            axios.post("https://super-bootcamp-backend.sanbersy.com/api/games", values, {headers: {"Authorization" : "Bearer "+ user.token}})
                .then(() => {
                    message.success('Data added successfully!')
                    history.push("/table-games")
                })
        } else {
            values.release = String(values.release)
            axios.put(`https://super-bootcamp-backend.sanbersy.com/api/games/${id}`, values, {headers: {"Authorization" : "Bearer "+ user.token}})
                .then(() => {
                    message.success('Data edited successfully!')
                    history.push("/table-games")
                })
        }
        
    }

    // const onFinishFailed = (error) => {
    //     console.log(error)
    // }
  

    // const HandleCange = (_,values) => {
    //     values.release = values.release.format("YYYY")
    //     console.log(values)
    // }

    
    const HandleCancel = () => {
        history.push("/table-games")
    }

    return (
        ready &&
        <Form
            name="games-form"
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete= "off" 
            labelCol={{
                span: 4,
              }}
              wrapperCol={{
                span: 14,
              }}

            initialValues={{
                name: gameEdit.name,
                genre: gameEdit.genre,
                platform: gameEdit.platform,
                release: gameEdit.release,
                singlePlayer: gameEdit.singlePlayer,
                multiplayer: gameEdit.multiplayer,
                image_url: gameEdit.image_url
            }}

            // onValuesChange={HandleCange}
            
        >
            <Form.Item
                label = "Name"
                name = "name"
                rules={[
                    {
                        required: true,
                        message: "Please input your name!"
                    }
                ]
                }           
            >
                <Input value="sss"/>
            </Form.Item>
            <Form.Item
                label = "Genre"
                name = "genre"
                rules={[
                    {
                        required: true,
                        message: "Please input your genre!"
                    }
                ]
                }
            
            >
                <Input />
            </Form.Item>
            <Form.Item
                label = "Platform"
                name = "platform"
                rules={[
                    {
                        required: true,
                        message: "Please input your platform!"
                    }
                ]
                }
            
            >
                <Input />
            </Form.Item>
            <Form.Item
                label= "Release"
                name="release"
                rules={[
                    {
                        required: true,
                        message: "Please input release year!"
                    }
                ]}
            >
                <InputNumber min={2000} max={2021}/>
            </Form.Item>
            <Form.Item
                label= "Single Player"
                name="singlePlayer"
                rules={[
                    {
                        required: true,
                        message: "Please input this field!"
                    }
                ]}
            >
                <InputNumber min={0} max={1}/>
            </Form.Item>
            <Form.Item
                label= "Multi Player"
                name="multiplayer"
                rules={[
                    {
                        required: true,
                        message: "Please input this field!"
                    }
                ]}
            >
                <InputNumber min={0} max={1}/>
            </Form.Item>
            <Form.Item
                label = "Image"
                name = "image_url"
                rules={[
                    {
                        required: true,
                        message: "Please input link image!"
                    }
                ]
                }
            
            >
                <Input/>
            </Form.Item>
            <Form.Item
                 wrapperCol={{
                    offset: 8,
                    span: 16,
                    }}
            >
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
                <Button type="danger" onClick={HandleCancel} style={{marginLeft: "20px"}}>
                    Cancel
                </Button>
            </Form.Item>
        </Form>
    )
}

export default GamesForm